import React, { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
} from "react-icons/fa";
import logoBranca from "../../images/Integrarq_Logo branca sem fundo.png";
import qrCode from "../../images/qr_integrarq_vcard.png";
import { LanguageContext } from "../../contexts/LanguageContext";
import {
  StyledFooter,
  FooterContent,
  FooterLogo,
  FooterLinks,
  FooterSocial,
  SocialIcons,
  FooterBottom,
  FooterQr,
} from "./styles";

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  return (
    <StyledFooter>
      <div className="container">
        <FooterContent>
          <FooterLogo>
            <a href="#inicio">
              <img src={logoBranca} alt="Integrarq" />
              <p className="branding">
                <span className="highlight">Pesquisa, Controladoria &</span>
                <br />
                <span className="white">BackOffice Jurídico</span>
              </p>
            </a>
          </FooterLogo>

          <FooterLinks>
            <h3>{translations[language].quickLinks || "Links rápidos"}</h3>
            <ul>
              <li>
                <a href="#inicio">{translations[language].home}</a>
              </li>
              <li>
                <a href="#servicos">{translations[language].services}</a>
              </li>
              <li>
                <a href="#sobre">{translations[language].about}</a>
              </li>
              <li>
                <a href="#contato">{translations[language].contact}</a>
              </li>
            </ul>
          </FooterLinks>

          <FooterSocial>
            <h3>{translations[language].socialMedia || "Redes sociais"}</h3>

            <SocialIcons>
              <a
                href="https://www.linkedin.com/company/integrarq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin color="#0A66C2" size={24} />
              </a>
              <a
                href="https://www.instagram.com/integrarqassessoria/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram color="#E1306C" size={24} />
              </a>
              <a
                href="https://www.facebook.com/integrarqassessoria"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF color="#1877F2" size={24} />
              </a>
              <a
                href="https://wa.me/5521969427579"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp color="#25D366" size={24} />
              </a>
            </SocialIcons>
          </FooterSocial>
          <FooterQr>
            <h3>Vamos conversar?</h3>
            <img src={qrCode} alt="QR Code para contato" />
          </FooterQr>

        </FooterContent>

        <FooterBottom>
          <p>
            &copy; {new Date().getFullYear()} Integrarq.{" "}
            {translations[language].allRightsReserved ||
              "Todos os direitos reservados."}
          </p>
        </FooterBottom>
      </div>
    </StyledFooter>
  );
};

export default Footer;
